import ActionTypes from "./ActionTypes";
import {createFilters} from "./convertDataRange";
import filterData from "./filterData";
import getSortedData  from "./../../../_utils/getSortedData";

const searchReducer = (state, action) => {
  let updateState = state;
  switch (action.type) {
    case ActionTypes.SET_ERROR:
      {updateState = { ...state, error: action.payload, isError: !!action.payload };
      break;}
    case ActionTypes.SET_LOADING:
     { updateState = { ...state, isLoading: action.payload };
      break;}
    case ActionTypes.SEARCHING_RESULTS:
  {    
    const filterQuery = createFilters({ ...state.filterQuery });
    const filteredResults = filterData(action.payload?.results, filterQuery);
    const sortedResults = getSortedData(filteredResults, state?.sortingOption);
    updateState = {
        ...state,
        filteredResults:sortedResults,
        searchResults: action.payload?.results,
        pagination: action.payload?.pagination,
      };
      break;}
    case ActionTypes.SET_FILTERS_QUERY:
    {  
      const filterQuery = createFilters({ ...state.filterQuery, ...action.payload });
      const filteredResults = filterData(state?.searchResults, filterQuery);
      updateState = { ...state, filteredResults, filterQuery: { ...state.filterQuery, ...action.payload } };
      break;}

    case ActionTypes.CLEAR_FILTERS:
{      updateState = {
        ...state,
        filterQuery: {},
      };
      break;}
    case ActionTypes.SET_SORTING_PARAMETERS:
     { const sortedResults = getSortedData(state?.filteredResults, action.payload);
      updateState = { ...state, filteredResults:sortedResults,sortingOption: action.payload };
      break;}
 
    case ActionTypes.SET_SEARCH_TERM:
     { updateState = { ...state, searchTerm: action.payload };
      break;}
    case ActionTypes.SET_STATE:
      {updateState = { ...state, ...action.payload };
      break;}
    case ActionTypes.HANDLE_RESET_FILTER:
      {updateState = { ...state, filterQuery: {}, filteredResults: [] };
      break;}
    default:
     { updateState = { ...state };
      break;}
  }
  return updateState;
};


export default searchReducer;